export default __webpack_public_path__ + "static/media/apple.da570a5b.svg";